"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Link.scss");
var Link = function Link(_ref) {
  var className = _ref.className,
    href = _ref.href,
    onClick = _ref.onClick,
    title = _ref.title,
    content = _ref.content;
  var rootClassName = (0, _classnames["default"])('cds-Dropdown-ListItemLink', {
    'cds-Link': !!href,
    'cds-ButtonLink': !href
  }, className);
  var handleClick = function handleClick(e) {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };
  if (content) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: rootClassName,
      onClick: handleClick
    }, content);
  }
  if (!href) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: rootClassName,
      onClick: handleClick
    }, title || '');
  }
  return /*#__PURE__*/_react["default"].createElement("a", {
    className: rootClassName,
    href: href,
    onClick: handleClick
  }, title || '');
};
exports.Link = Link;